import Actions from "./actions";
import DynamicForms from "./dynamicForms";
import FlraItems from "./flraItems";
import PlantLocation from "./plantLocation";
import WorkingBranches from "./workingBranches";
import JobCats from "./jobCats";
import Employee from "./employee";
import Tags from "./tags";
import FormTemplates from "./formTemplates";
import FormTemplatesResponse from "./formTemplatesResponse";
import FormPages from "./formPages";
import FormVersionHistory from "./formVersionHistory";
import FormFields from "./formFields";
import FlraForms from "./flraForms";
import PreDefinedList from "./preDefinedList";
import PdfLayout from "./pdfLayout";
import ShippingRequests from "./shippingRequests";
import TriggerSettings from "./triggerSettings";
import Profiles from "./profiles";
import AppSettings from "./appSettings";
import Sequence from "./sequence";
import Attachments from "./attachments";
import EmailQueue from "./emailQueue";
import RxdbSchemas from "./rxdbSchemas";
import JobPlanInfo from "./jobPlanInfo";
import LwiDash from "./lwiDash";
import Exceptions from "./exceptions";
import Blades from "./blades";
import PatrolReport from "./patrolReport";
import Permissions from "./permissions";
import MasterData from "./masterData";
import FlhaItems from "./flhaItems";
import EmailTemplates from "./emailTemplates";
import MailDistributionGroups from "./mailDistributionGroups";
import SchemaBrowser from "./schemaBrowser";
import DynamicReport from "./dynamicReport";
import BladeTypes from "./bladeTypes";
import Signatures from "./signatures";

export default {
  Actions,
  DynamicForms,
  FlraItems,
  FlraForms,
  PlantLocation,
  WorkingBranches,
  JobCats,
  Employee,
  Tags,
  FormTemplates,
  FormTemplatesResponse,
  FormPages,
  FormVersionHistory,
  FormFields,
  PreDefinedList,
  PdfLayout,
  ShippingRequests,
  TriggerSettings,
  Profiles,
  AppSettings,
  Sequence,
  Attachments,
  EmailQueue,
  RxdbSchemas,
  JobPlanInfo,
  LwiDash,
  Exceptions,
  Blades,
  PatrolReport,
  Permissions,
  MasterData,
  FlhaItems,
  EmailTemplates,
  MailDistributionGroups,
  SchemaBrowser,
  DynamicReport,
  BladeTypes,
  Signatures
};
